function CustomMarkerIcon({ Icon, className }) {
    return <Icon className={className} />;
  }
  export default CustomMarkerIcon;
  